// The Sanskrit course's page metadata: the site-wide <Seo> with "Sanskrit Suvaani" as the site name.

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { Seo as SiteSeo } from '@/components/generals/seo'

const SANSKRIT_DESCRIPTION = 'Learn Classical Sanskrit from zero with guided lessons, an animated teacher board, verb and noun labs, sandhi, stories and spaced revision.'

export const Seo: FC<SeoProps> = ({ title, description = SANSKRIT_DESCRIPTION, ogImage = '/images/sanskrit/hero.jpg', noIndex }): ReactNode => (
    <SiteSeo title={title} description={description} ogImage={ogImage} site='Sanskrit Suvaani' noIndex={noIndex} />
)
